import { IconTag, Stack } from '@vtex/admin-ui'
import { FormState } from '@vtex/admin-ui-form'
import { useBrands } from 'hooks'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { DefaultProps } from 'typings'
import { MultiSelect } from '../../../MultiSelect'
import { DownloadButton } from '../DownloadButton'
import { ImportButton } from '../ImportButton'
import { SelectorHeader } from '../SelectorHeader'
import messages from './messages'
import { LIMITS } from 'shared'

interface BrandSelectorProps {
  name: string
  state?: FormState
  loading?: boolean
  placeholder?: string
}

function Header(props: DefaultProps) {
  const { children } = props

  const { $t } = useIntl()

  return (
    <SelectorHeader label={$t(messages.label)} Icon={IconTag}>
      {children}
    </SelectorHeader>
  )
}

function Selector(props: BrandSelectorProps) {
  const { name, state, placeholder, loading } = props

  const { formatMessage: i18n } = useIntl()

  const [searchTerm, setSearchTerm] = useState('')

  const { data: options, isLoading } = useBrands(searchTerm)

  return (
    <MultiSelect
      name={name}
      options={options ?? []}
      label={placeholder ?? i18n(messages.placeholder)}
      loading={loading}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
      state={state}
      maxEntries={LIMITS.MAX_BRANDS}
    />
  )
}

export function BrandsSelector(props: DefaultProps) {
  return (
    <Stack space="$space-2" fluid>
      {props.children}
    </Stack>
  )
}

BrandsSelector.Header = Header
BrandsSelector.Download = DownloadButton
BrandsSelector.Upload = ImportButton
BrandsSelector.Selector = Selector
